export interface DescriptionToken {
  text: string;
  href?: string;
}

const LINK = /\[([^\]]+)\]\(([^)\s]+)\)/g;

const isAllowed = (url: string) => /^(https?:\/\/|\/)/.test(url);

export const parseDescription = (text: string): DescriptionToken[] => {
  const tokens: DescriptionToken[] = [];
  let last = 0;

  for (const match of text.matchAll(LINK)) {
    const [whole, label, url] = match;
    const start = match.index ?? 0;

    if (start > last) {
      tokens.push({ text: text.slice(last, start) });
    }

    tokens.push(isAllowed(url) ? { text: label, href: url } : { text: whole });
    last = start + whole.length;
  }

  if (last < text.length) {
    tokens.push({ text: text.slice(last) });
  }

  return tokens;
};
